<script>
import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default ({
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ['chartData'],
  data() {
    return {
      options: {
        responsive: true,

        // ★[tooltips]を追加
        tooltips: {
         bodyFontSize: 28,
          callbacks: {
            label: function(tooltipItem, data) {
              let total = 0 // 合計格納
              let indexItem = data.datasets[0].data[tooltipItem.index] // マウスを当てたデータ
              // 全データの合計算出
              data.datasets[0].data.forEach(item => {
                total += item
              })
              // パーセント表示
              return Math.round(indexItem / total * 100) + ' %'
            }
          }
        }
      }
    }
  },
  watch:{
      chartData:{
        handler: function(val, oldVal) {
          console.log("変更"+val,oldVal)
          this.renderChart(this.chartData, this.options)
        }
      }
    },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
})
</script>
